import * as React from "react";
import HeaderBar from "./commons/components/HeaderBar";
import UserCardMedium from "./commons/components/user/UserCardMedium";
import UserInfo from "./commons/model/UserInfo";
import "./SettingsAccount.scss";
import { createRoot } from "react-dom/client";

export default function SettingsAccount({ user }: { user: UserInfo }) {
  return (
    <>
      <HeaderBar title={i18n["Page.Settings.Account.Title"]} />
      <div className="content">
        <div className="profile">
          <div className="panel with-shadow">
            <div className="panel-title">{i18n["Page.Settings.Account.Profile.Title"]}</div>
            <UserCardMedium user={user} />
          </div>
        </div>
      </div>
    </>
  );
}

SettingsAccount.loadComponent = (elementId: string, props) => {
  const container = document.getElementById(elementId);
  const root = createRoot(container!);
  root.render(<SettingsAccount {...props} />);
};
